import React from "react";

//MUI
import SvgIcon from '@mui/material/SvgIcon';

//Types
import { SvgIconProps } from "@mui/material";

function PlaninarskaKucaIcon(props: SvgIconProps) {
  return <SvgIcon {...props}>
    <svg version="1.1" id="PlaninarskaKucaIcon" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
      width="100px" height="100px" viewBox="0 0 100 100"
      style={{
        //@ts-ignore
        enableBackground: "new 0 0 100 100"
      }}
      xmlSpace="preserve">
      <path fill="#FFFFFF" d="M87.7,50.5v-7.6L50,13.1L12.3,42.9v7.6h6.5v20.8h-5v12.3h72.4V71.3h-5V50.5H87.7z" />
      <path fillRule="evenodd" clipRule="evenodd" fill="#FF0000" d="M17.6,79.9v-4.7h5V46.7h-6.5v-2L50,18l33.9,26.8v2h-6.5v28.4h5v4.7
	C82.4,79.9,17.6,79.9,17.6,79.9z M29.6,50.7h9v12h-9C29.6,62.7,29.6,50.7,29.6,50.7z M61.5,50.7h9v12h-9V50.7z M44.3,75.1h11.5V57.7
	H44.3V75.1z"/>
    </svg>
  </SvgIcon>
}

export default PlaninarskaKucaIcon;
